import '../polyfills/polyfill.forEach';

const mobileMenu = () => {
  const toggleElements = document.querySelectorAll('[data-toggle]');

  const handleMobileDropdownClick = (event) => {
    event.preventDefault();
  
    const clickedElement = event.currentTarget;
    const targetElement = document.querySelector(clickedElement.getAttribute('data-target'));
  
    if (targetElement.classList.contains('mobile-menu__dropdown--opened')) {
      // remove the class
      targetElement.classList.remove('mobile-menu__dropdown--opened');
      clickedElement.classList.remove('mobile-menu__link--dropdown-active');
    } else {
      // add the class
      targetElement.classList.add('mobile-menu__dropdown--opened');
      clickedElement.classList.add('mobile-menu__link--dropdown-active');
    }
  };
  
  const handleMobileMenuClick = (event) => {
    event.preventDefault();
  
    const clickedElement = event.currentTarget;
    const targetElement = document.querySelector(clickedElement.getAttribute('data-target'));
    const scrollY = window.scrollY;
  
    // console.log(scrollY);
  
    if (targetElement.classList.contains('mobile-menu--opened')) {
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
  
      // remove the class
      targetElement.classList.remove('mobile-menu--opened');
    } else {
      // add the class
      targetElement.classList.add('mobile-menu--opened');
  
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}`;
    }
  };
  
  toggleElements.forEach((element) => {
    const type = element.getAttribute('data-toggle');
  
    switch (type) {
      case 'mobile-dropdown':
        element.addEventListener('click', handleMobileDropdownClick);
        break;
      case 'mobile-menu':
        element.addEventListener('click', handleMobileMenuClick);
        break;
    }
  });
  
  window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    document.querySelector('.mobile-menu').style.height = window.innerHeight + 'px';
  },false);
}

export default mobileMenu;